import React, {useState, useEffect} from 'react'
import * as txApi from '../clients/tx-sls-client'

export const useAnglerPinnedTournaments = (user_information) => {
    //console.log('user_information value passed for getting pinned tournaments::', user_information);

    const set_user_information = user_information ;
   
    const [pinned_tournaments, setPinnedTournaments] = useState([])
    const [isShowPinIcon, setPinLoaded] = useState(false)

    if(set_user_information){

       
      //console.log('set_user_information value passed for getting pinned tournaments::', set_user_information); console.log('set_user_information value passed for getting pinned tournaments::', set_user_information);

      // Get logged in user role  user_id
      // Also check if super-admin is emulating any role, to get his role vale

      if(set_user_information && set_user_information.emulate_user_id){

        var user_id = set_user_information.emulate_user_id;

      }else{
        
        // Get user_id of logged in user
        var user_id = set_user_information.user_id;

      }
      
      
      if (isShowPinIcon === false ) {
        txApi.getAnglerPinnedTournaments(user_id)
        .then( pinnedTournaments => {
    
          if(pinnedTournaments.length > 0 ){
                setPinLoaded(true)
                setPinnedTournaments(pinnedTournaments)
                console.log('setPinnedTournaments response received:::', pinnedTournaments);
          }
        })
        .catch(error => {
          console.log(`Error retrieving pinned tournament details for user id ${user_id}`,error); 
        })
      }
    }

    useEffect(() => {
      
    },[]);

    return pinned_tournaments
}